
export class StaticMemory {
    public static isAuthVerified = false;
    public static xRoute = '&T(%^&IYU6756856iyku,gKYUGL>IUH' + window.location.hostname;
}
